import React from 'react';

interface VoteStatusProps {
  totalPlayers: number;
  votesCasted: number;
  votesRevealed: boolean;
}

const VoteStatus: React.FC<VoteStatusProps> = ({ totalPlayers, votesCasted, votesRevealed }) => {
  if (!totalPlayers) {
    return <p className="vote-status">Invite your teammates to join the session.</p>;
  }

  if (votesRevealed) {
    return <p className="vote-status vote-status--revealed">All votes are revealed!</p>;
  }

  const remaining = totalPlayers - votesCasted;
  const message = remaining === 0 ? 'All votes are in. Revealing…' : `${remaining} ${remaining === 1 ? 'person' : 'people'} left to vote.`;

  return (
    <p className="vote-status">
      <strong>{votesCasted}</strong>/<strong>{totalPlayers}</strong> ready — {message}
    </p>
  );
};

export default VoteStatus;
